import { Link } from "@inertiajs/react";

type Props = {
  children: React.ReactElement;
};

export default function Layout({ children }: Props) {
  return (
    <main>
      <header>
        <Link href="/notes">notes</Link> | <Link href="/people">people</Link> |{" "}
        profile (
        <Link href={`/users/sign_out`} method="delete">
          sign out
        </Link>
        )
      </header>
      <div>{children}</div>
    </main>
  );
}
